export const ROOT_URI = '/agencyAdministration';

const AgencyAdministrationRouteConstants = {
  AGENTS: `${ROOT_URI}`,
  AGENTS_BY_NAME: (name: string) => `${ROOT_URI}?agentName=${name}`,
  AGENTS_BY_LAST_NAME: (lastName: string) => `${ROOT_URI}?lastName=${lastName}`,
};

export default AgencyAdministrationRouteConstants;
